import Cookies from "js-cookie";
import axios from "../../../../../axios";

export const VerifyTaskCompletion = async (query, signal) => {
	const token = localStorage.getItem("token");

	try {
		const res = await axios.post(
			"/api/Admin/VerifyTaskCompletion",
			{ query },
			{
				headers: { Authorization: `Bearer ${token}` },
				timeout: 6 * 60 * 1000, // backend allows Ollama up to 5 min
				signal,
			}
		);
		return res.data;
	} catch (err) {
		// 400 / 404 come back as exceptions in axios; surface the API message
		const message =
			err?.response?.data?.message ||
			err?.response?.data?.Message ||
			(err.code === "ECONNABORTED"
				? "The AI took too long to respond. Try a narrower question."
				: "Something went wrong. Please try again.");
		throw new Error(message);
	}
};

